!function (e, t) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = t(require("react"), require("classnames"), require("@material/react-ripple/dist/index.js"));else if ("function" == typeof define && define.amd) define(["react", "classnames", "@material/react-ripple/dist/index.js"], t);else {
    var r = "object" == typeof exports ? t(require("react"), require("classnames"), require("@material/react-ripple/dist/index.js")) : t(e.react, e.classnames, e["@material/react-ripple/dist/index.js"]);

    for (var n in r) {
      ("object" == typeof exports ? exports : e)[n] = r[n];
    }
  }
}("undefined" != typeof self ? self : this, function (e, t, r) {
  return function (e) {
    var t = {};

    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        r.d(n, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 97);
  }({
    0: function _(t, r) {
      t.exports = e;
    },
    1: function _(e, r) {
      e.exports = t;
    },
    5: function _(e, t) {
      e.exports = r;
    },
    97: function _(e, t, r) {
      "use strict";

      var _n,
          o = this && this.__extends || (_n = function n(e, t) {
        return (_n = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(e, t);
      }, function (e, t) {
        function r() {
          this.constructor = e;
        }

        _n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r());
      }),
          i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, r = 1, n = arguments.length; r < n; r++) {
            for (var o in t = arguments[r]) {
              Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
            }
          }

          return e;
        }).apply(this, arguments);
      },
          a = this && this.__rest || function (e, t) {
        var r = {};

        for (var n in e) {
          Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
        }

        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;

          for (n = Object.getOwnPropertySymbols(e); o < n.length; o++) {
            t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
          }
        }

        return r;
      },
          u = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var p = u(r(0)),
          l = u(r(1)),
          s = r(5),
          c = function c(e) {
        var t = e.className,
            r = e.icon,
            n = e.initRipple,
            o = e.hasRipple,
            u = (e.unbounded, a(e, ["className", "icon", "initRipple", "hasRipple", "unbounded"])),
            s = l.default("material-icons", t, {
          "material-icons--ripple-surface": o
        });
        return p.default.createElement("i", i({
          className: s,
          ref: n
        }, u), r);
      };

      t.RippleMaterialIcon = s.withRipple(c);

      var f = function (e) {
        function r() {
          return null !== e && e.apply(this, arguments) || this;
        }

        return o(r, e), r.prototype.render = function () {
          var e = this.props,
              r = e.icon,
              n = e.hasRipple,
              o = (e.unbounded, a(e, ["icon", "hasRipple", "unbounded"]));
          return n ? p.default.createElement(t.RippleMaterialIcon, i({
            unbounded: !0,
            hasRipple: !0,
            icon: r
          }, o)) : p.default.createElement(c, i({
            icon: r
          }, o));
        }, r.defaultProps = {
          icon: "",
          className: "",
          hasRipple: !1,
          unbounded: !1
        }, r;
      }(p.default.Component);

      t.default = f;
    }
  });
});